import ApiService from './ApiService.js';
const uuidv1 = require('uuid/v1');

var NotificationService = {
    findAll: function($data)
     {
        return new Promise(function(resolve,reject) {
            var $options= {};
            $options.url ="notification"
            $options.method="get"
            if(!$data) {
                $options.data = $data
            }
            ApiService.request($options)
                .then(response => {
                   // console.log('Gpt the data');
                    resolve(response.data.data)
                }).catch(error=> {
                    reject(error);
                })
        });

    },

    
    CreateNotification: function ($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            console.log($data)
            //$options.data.id =  uuidv1();
           
            $options.data.title= $data.title;
            $options.data.message= $data.message;
            $options.data.attachments= $data.attachments;
            $options.data.users = $data.users
            $options.data.read_receipt = $data.read_receipt
            $options.url = "notification/"
            $options.method="post"
            console.log($options)
            ApiService.request($options)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                });
            });
    },
   
};
export default NotificationService;